import styled from 'styled-components';

export const FullScreen = styled.div`
  position: relative;
  min-height: 100%;
  display: flex;
  justify-content: center;
`;
